/* eslint-disable no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
import { useState, useEffect } from 'react';
import { create, insert, search } from '@orama/orama';
import PropTypes from 'prop-types';
import {
  Box,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
  Select,
  MenuItem,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Snackbar,
} from '@mui/material';
import EllipsisText from 'react-ellipsis-text';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import useTranslations from '../data/useTranslations';
import useUser from '../data/useUser';
import TranslationDialog from './TranslationDialog';
import useAuthContext from '../auth/useAuthContext';
import useProjects from '../data/useProjects';
import TranslationField from './TranslationField';
import '../styles.css';

// eslint-disable-next-line no-unused-vars

function Translations({ currentProject }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedTr, setSelectedTr] = useState();
  const [selectedtra, setSelectedtra] = useState([]);
  const [plugin, setPlugin] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredTranslations, setFilteredTranslations] = useState([]);
  const [pluginname, setPluginname] = useState(null);

  const [selectall, setSelectAll] = useState(false);
  const project = currentProject;
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const handleDeleteConfirmationOpen = () => {
    setDeleteConfirmationOpen(true);
  };
  const handleDeleteConfirmationClose = () => {
    setDeleteConfirmationOpen(false);
  };

  const { user } = useAuthContext();
  const {
    translations, isLoading, isError,
    deleteTranslation, addTranslation, importTranslations, getplugin, downloadTranslation,
  } = useTranslations({ user, project });
  const { data } = useUser({ user });
  console.log('Current Project: ', data && data.item.Items[0]?.currentProject);
  const { projects } = useProjects({ user });
  console.log(projects);
  const full = projects && projects.find((p) => p.project === project);
  const dcode = full && full.defaultLang?.code;
  const dname = full && full.defaultLang?.name;
  const languages = full && full.languages;
  console.log('translations', translations);
  const [key, setKey] = useState('');
  const [srcText, setSrcText] = useState('');
  const [destTexts, setDestTexts] = useState({
  });
  const [, setIsLoadingPrevious] = useState(false);
  const theme = useTheme();
  const [page, setPage] = useState(0);
  const [numtrans, setNumtrans] = useState(10);
  const [limitPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handlePageChange = (event) => {
    if (event && event.target && event.target.value) {
      setPage(event.target.value);
    }
  };

  async function searchTranslations(searchTerm) {
    // Create orama translationDB using the same schema as in the Orama code
    const translationDB = await create({
      schema: {
        trkey: 'string',
        Type: 'string',
        Translations: {
          // Add dynamic languages to the schema
          ...(languages && languages.length > 0 && languages.reduce((translationsObj, language) => {
            const translations = { ...translationsObj };
            translations[language.code] = 'string';
            return translations;
          }, {})),
        },
      },
      components: {
        tokenizer: {
          stopWords: false,
        },
      },
    });

    // Insert translations from your existing data into the translationDB
    const insertion = translations.map((item) => insert(translationDB, {
      trkey: item.trkey,
      Translations: {
        // Use the dynamic languages
        ...(languages && languages.length > 0 && languages.reduce((translationsObj, language) => {
          const translations = { ...translationsObj };
          translations[language.code] = item[language.code] || '';
          return translations;
        }, {})),
      },
    }));
    await Promise.all(insertion);

    // Perform the search using the provided searchTerm and desired properties
    const searchResult = await search(translationDB, {
      term: searchTerm,
      properties: '*',
      exact: false,
    });

    const formattedTranslations = searchResult.hits.map((hit) => ({
      ...hit.document,
      ...languages.reduce((translationsObj, language) => {
        const translations = { ...translationsObj };
        translations[language.code] = hit.document.Translations[language.code];
        return translations;
      }, {}),
    }));

    setFilteredTranslations(formattedTranslations);

    // Return the search result to be used in your component
    return searchResult;
  }

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    // Call the searchTranslations function when the searchTerm or page changes
    const performSearch = async () => {
      const searchResult = await searchTranslations(searchTerm);
      // Use the search result as needed, e.g., update the displayed translations
      console.log('Search Result:', JSON.stringify(searchResult, null, 2));
    };

    performSearch();
  }, [searchTerm, page]);

  const fetchPlugins = async () => {
    try {
      const plugins = await getplugin();
      setPlugin(plugins);
      console.log(plugins);
    } catch (error) {
      console.error('Error fetching plugins:', error);
    }
  };
  console.log(plugin);
  if (plugin.length === 0) {
    fetchPlugins();
  }
  const { onPageChange } = { count: translations.length, onPageChange: handleChangePage };

  const handleFirstPageButtonClick = async (event) => {
    onPageChange(event, 0);
    setIsLoadingPrevious(true);
  };
  const handleDeleteSelected = () => {
    // Delete the selected translations using the selectedTranslations array
    selectedtra.forEach((trkey) => deleteTranslation(trkey));
    // Clear the selectedTranslations array
    setSelectedtra([]);
  };

  const handleBackButtonClick = async (event) => {
    onPageChange(event, page - 1);
    setIsLoadingPrevious(true);
  };

  const handleNextButtonClick = async (event) => {
    const totalPages = Math.ceil(translations.length / numtrans);
    if (page + 1 < totalPages) {
      onPageChange(event, page + 1);
    }
  };
  const handleFileInputChange = async (event) => {
    try {
      if (pluginname === null) {
        window.alert('Please Select A Plugin before Import');
        return;
      }
      const filee = event.target.files[0];
      const reader = new FileReader();
      reader.readAsArrayBuffer(filee);

      const filedata = await new Promise((resolve) => {
        reader.onload = () => resolve(reader.result);
      });
      const importing = await importTranslations(filedata, pluginname);
      if (importing === 'success') {
        setMessage('File uploaded');
        setSeverity('success');
        setOpen(true);
      } else {
        setMessage('Please check the Zip file again');
        setSeverity('error');
        setOpen(true);
      }

      console.log(importing);
      // const zip = await JSZip.loadAsync(data);
      // const translationss = {};
      // await Promise.all(
      //   Object.entries(zip.files).map(async ([filename, file]) => {
      //     if (file.dir || !filename.endsWith('.json')) return;
      //     const json = await file.async('string');
      //     console.log(json);
      //     const language = filename.slice(0, -5);
      //     translationss[language] = JSON.parse(json);
      //   }), // here above translations is converted to nualang format
      // );
      // console.log(translationss);
      // const newList = Object.keys(translationss[Object.keys(translationss)[0]]).map((key) => {
      //   const newObj = { trkey: key };
      //   Object.keys(translationss).forEach((langKey) => {
      //     newObj[langKey] = translationss[langKey][key];
      //   });
      //   return newObj;
      // });
      // const result = newList.map((o) => ({
      //   ...o,
      //   project: currentProject,
      //   user,
      // }));
      // console.log('resuly', result);
      // importTranslations(result);
      // console.log(newList);
      // setTranslations(newList);
    } catch (error) {
      console.error('Sending data:', error);
    }
  };
  let color;
  if (severity === 'success') {
    color = 'green';
  } else if (severity === 'error') {
    color = 'red';
  } else {
    color = 'orange';
  }

  const handleSelectTranslation = (trkey) => {
    if (selectedtra.includes(trkey)) {
      setSelectedtra(selectedtra.filter((keey) => keey !== trkey));
    } else {
      setSelectedtra([...selectedtra, trkey]);
    }
    console.log(selectedtra);
  };
  const handleSelectAll = () => {
    if (selectall) {
      setSelectedtra([]);
    } else {
      const allTranslations = translations.map((item) => item.trkey);
      setSelectedtra(allTranslations);
    }
    setSelectAll(!selectall);
  };

  function handleDelete(keay) {
    console.debug(`Delete ${keay}`);
    deleteTranslation(keay);
  }

  function handleEditTr(event, translation) {
    setDialogOpen(true);
    setSelectedTr(translation);
    console.debug(`Edit ${JSON.stringify(selectedTr)}`);
  }

  function handleCreateTr() {
    setDialogOpen(true);
    setSelectedTr(null);
    console.debug(`Edit ${JSON.stringify(selectedTr)}`);
  }
  if (isError) {
    return <div>failed to load</div>;
  }
  if (isLoading) {
    return <CircularProgress />;
  }

  if (!translations) {
    return null;
  }

  function handleSubmit(event) {
    event.preventDefault();
    console.log('source text', srcText);
    console.log('default language', dcode);
    addTranslation({
      trkey: key,
      [dcode]: srcText,
      ...destTexts,
    });
  }

  const handleDownload = async () => {
    if (pluginname === null) {
      window.alert('Please Select A Plugin before Download');
      return;
    }
    const response = await downloadTranslation(pluginname);
    const { url } = response;
    console.log(url);

    const link = document.createElement('a');
    link.href = url;
    link.click();
  };

  console.debug(`Translations is ${JSON.stringify(translations, null, 2)}`);
  console.log(pluginname);

  // eslint-disable-next-line max-len
  const displayTranslations = searchTerm ? filteredTranslations : translations.slice(page * numtrans, page * numtrans + numtrans);
  console.log('displayed translations', JSON.stringify(displayTranslations, null, 2));

  const lastPage = Math.floor(translations.length / numtrans); // Calculate the last page

  return (

    <Box>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message={message}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        ContentProps={{
          sx: {
            backgroundColor: color,
          },
        }}
      />

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          label='Search Translations'
          variant='outlined'
          value={searchTerm}
          onChange={handleSearch}
        />

        <Button onClick={handleDownload}>
          Download

        </Button>
        {/* {translations.length === 0 ? <TranslationImport /> : null} */}
        <Select
          onChange={(e) => {
          // const pluginname = e.target.value;
            setPluginname(e.target.value);
          }}
          sx={{ width: '20ch' }}
        >
          {plugin.length > 0 && plugin?.map((pluginn) => (
            <MenuItem key={pluginn} value={pluginn}>
              {pluginn}
            </MenuItem>
          ))}
        </Select>

      </div>
      {' '}
      {/*   <LoadTranslations /> */}

      {translations.length === 0 ? (
        <div style={{ display: 'flex' }}>
          <label>

            <input type='file' accept='.zip' style={{ display: 'none' }} onChange={handleFileInputChange} />
            <h4 className='custom-file-upload'>Upload file</h4>
          </label>
        </div>
      ) : null}
      <IconButton aria-label='add' onClick={(event) => handleCreateTr(event, {})}>
        <AddCircleOutlineIcon />
      </IconButton>

      <TranslationDialog
        key={Math.floor(Math.random() * 5000)}
        translation={selectedTr}
        open={dialogOpen}
        handleClose={() => setDialogOpen(false)}
      />
      <div style={{ overflowX: 'auto' }}>
        <TableContainer component={Paper}>
          <Table
            sx={{ minWidth: 650 }}
            size='small'
            aria-label='a dense table'
          >
            <TableHead>
              <TableRow>
                <Checkbox
                  checked={selectall}
                  onChange={handleSelectAll}
                />
                { selectedtra.length > 0 && (
                  <>
                    <Dialog open={deleteConfirmationOpen} onClose={handleDeleteConfirmationClose}>
                      <DialogTitle>CONFIRM DELETION</DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          <b> Are you sure you want to delete the selected translations? </b>
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleDeleteConfirmationClose} variant='contained' color='primary'>
                          Cancel
                        </Button>
                        <Button onClick={handleDeleteSelected} variant='contained' color='error'>
                          Delete
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <Button onClick={handleDeleteConfirmationOpen}>
                      <DeleteIcon />
                    </Button>
                  </>
                )}
                <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', minWidth: 100 }}>Key</TableCell>
                <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', minWidth: 200 }}>{dname}</TableCell>
                {languages && languages.map((language) => (language.code !== dcode ? (
                  <TableCell key={language.code} sx={{ fontWeight: 'bold', textAlign: 'center', minWidth: 200 }}>
                    {language.name}
                  </TableCell>
                ) : null
                ))}
                <TableCell />
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {translations.length === 0 }
              {(limitPerPage > 0
                ? displayTranslations
                : displayTranslations
              ).map((item, index) => (
                <TableRow
                  key={item.trkey}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <Checkbox
                    checked={selectedtra && selectedtra.includes(item.trkey)}
                    onChange={() => handleSelectTranslation(item.trkey)}
                  />
                  <TableCell sx={{ textAlign: 'center', minWidth: 100 }}>{item.trkey}</TableCell>
                  <TableCell sx={{ textAlign: 'center', minWidth: 100 }}>
                    {' '}
                    {item[dcode] ? <EllipsisText text={`${item[dcode]}`} length='20' /> : ''}
                  </TableCell>
                  {languages && languages.map((language) => (language.code !== dcode ? (

                    <TableCell key={language.code} sx={{ fontWeight: 'bold', textAlign: 'center', minWidth: 200 }}>

                      {item[language.code] ? <EllipsisText text={`${item[language.code]}`} length='20' /> : ''}

                    </TableCell>

                  ) : null
                  ))}
                  <TableCell sx={{ textAlign: 'center' }}>
                    <IconButton
                      aria-label='delete'
                      onClick={() => handleDelete(item.trkey)}
                      sx={{ p: '1px' }}
                    >
                      <DeleteIcon fontSize='small' />
                    </IconButton>
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    <IconButton
                      aria-label='edit'
                      onClick={(event) => handleEditTr(event, translations[index])}
                      sx={{ p: '1px' }}
                    >
                      <EditIcon fontSize='small' />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </TableContainer>
      </div>
      <div className='select-container'>
        {translations.length > 0 && (
        <Box sx={{
          flexShrink: 0, ml: 2.5, display: 'flex', justifyContent: 'center',
        }}
        >
          <Select
            value={numtrans}
            onChange={(e) => {
              const newPage = e.target.value;
              setNumtrans(newPage);
              handlePageChange(newPage);
            }}
            sx={{ width: '8ch' }}
            disabled={page !== 0}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
          <IconButton
            onClick={handleFirstPageButtonClick}
            disabled={page === 0}
            aria-label='first page'
            size='large'
            sx={{ color: theme.palette.primary.main }}
          >
            {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
          </IconButton>
          <IconButton
            onClick={handleBackButtonClick}
            disabled={page === 0}
            aria-label='previous page'
            size='large'
            sx={{ color: theme.palette.primary.main }}
          >
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
          </IconButton>
          <IconButton
            onClick={handleNextButtonClick}
            // disabled={isLastPage}
            disabled={page === lastPage}
            aria-label='next page'
            size='large'
            sx={{ color: theme.palette.primary.main }}
          >
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </IconButton>
        </Box>
        )}
      </div>
      <hr />
      {/* This is a separate Add row below main table */}
      <form onSubmit={handleSubmit}>
        <div style={{ overflowX: 'auto', display: 'flex' }}>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size='small'
              aria-label='editable table row'
            >
              <TableBody>
                <TableRow selected sx={{ display: 'flex' }}>
                  <TableCell sx={{ textAlign: 'left', display: 'flex', minWidth: 1200 }}>
                    {' '}
                    <TextField
                      size='small'
                      label='Key'
                      name='key'
                      value={key}
                      sx={{ paddingLeft: 1 }}
                      onChange={(e) => setKey(e.target.value)}
                    />
                    <TextField
                      size='small'
                      label={dname}
                      name={dcode}
                      value={srcText}
                      sx={{ paddingLeft: 1 }}
                      onChange={(e) => setSrcText(e.target.value)}
                    />
                    {languages && languages.map((t) => (t.code !== dcode ? (
                      <TranslationField
                        key={t.code}
                        label={t.name}
                        sx={{ paddingLeft: 1 }}
                        srcLang={dcode}
                        destLang={t.code}
                        srcText={srcText}
                        value={destTexts[t.code]}
                        size='small'
                        onChange={(val) => setDestTexts((prev) => ({ ...prev, [t.code]: val }))}
                      />
                    ) : null))}

                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className='translation'>
          <Button type='submit'>Create Translation</Button>
        </div>
      </form>

    </Box>
  );
}

Translations.propTypes = {
  currentProject: PropTypes.string,
};

Translations.defaultProps = {
  currentProject: '',
};

EllipsisText.propTypes = {
  text: PropTypes.string.isRequired,
  length: PropTypes.string.isRequired,
  tail: PropTypes.string,
  tailClassName: PropTypes.string,
  tooltip: PropTypes.shape({
    copyOnClick: PropTypes.bool,
    onAppear: PropTypes.func,
    onDisapepear: PropTypes.func,
  }),
};

export default Translations;
